export class Equipment {
    id : number;
    designation : string;
    abbreviation : string;
    description : string;
    reference : string;
    establishment_id : number = JSON.parse(localStorage.getItem('user-infos')).establishment_id;

}
